export default "__VITE_ASSET__CbXAx1YB__"